import Input from './Input';


Input.install = function(Vue) {
  Vue.component(Input.name, Input);
};

export default Input;
